// This shows a dedicated error dialog, outside of Vue and without Bootstrap's JS, under the assumption that if we
// received an unhandled error anything could've gone wrong:
import { systemName } from '@/router/route-constants.ts';

function errorModalShow(messageHtml: string, rawError: unknown) {
  const clone = (document.getElementById('error-dialog') as HTMLTemplateElement).content.cloneNode(
    true,
  ) as DocumentFragment;

  (clone.querySelector('.modal-body div') as HTMLParagraphElement).innerHTML = messageHtml;
  let errorMessage = '';
  if (
    rawError instanceof Error ||
    (rawError && typeof rawError === 'object' && 'message' in rawError && 'stack' in rawError)
  ) {
    errorMessage = rawError.message + '\n\n' + rawError.stack;
  } else {
    errorMessage = String(rawError);
  }
  (clone.querySelector('.modal-body code') as HTMLElement).innerText = errorMessage;

  const backdrop = document.createElement('div');
  backdrop.classList.add('modal-backdrop', 'show');

  const closeBtn = clone.querySelector('.modal-footer button')!;
  closeBtn.addEventListener('click', () => {
    closeBtn.closest('.modal')!.remove();
    backdrop.remove();
  });

  document.body.appendChild(clone);
  document.body.appendChild(backdrop);
  console.error('Raw error:');
  console.error(rawError);
}

function isFirebaseError(rawError: unknown): boolean {
  let errorMessage = '';
  if (
    rawError instanceof Error ||
    (rawError && typeof rawError === 'object' && 'message' in rawError && 'stack' in rawError)
  ) {
    errorMessage = rawError.message + '\n\n' + rawError.stack;
  } else {
    errorMessage = String(rawError);
  }

  return errorMessage.includes('FirebaseError');
}

let firebaseModalIsAlreadyShowing = false;
function errorModalFirebaseShow(rawError: unknown) {
  if (firebaseModalIsAlreadyShowing) {
    return;
  }

  const clone = (document.getElementById('error-dialog-firebase') as HTMLTemplateElement).content.cloneNode(
    true,
  ) as DocumentFragment;

  const backdrop = document.createElement('div');
  backdrop.classList.add('modal-backdrop', 'show');

  const buttonReload = clone.querySelector('button[data-action="reload"]');
  const buttonClose = clone.querySelector('button[data-action="close"]');

  buttonReload?.addEventListener('click', function () {
    location.reload();
    firebaseModalIsAlreadyShowing = false;
  });
  buttonClose?.addEventListener('click', function () {
    buttonClose.closest('.modal')!.remove();
    backdrop.remove();
    firebaseModalIsAlreadyShowing = false;
  });

  document.body.appendChild(clone);
  document.body.appendChild(backdrop);
  firebaseModalIsAlreadyShowing = true;
  console.error('Raw error:');
  console.error(rawError);
}

const standardErrorMessage = `<p>We ran into an error fetching your data. This is likely caused by network or firewall settings established by the Company.</p><p>Please contact your IT group for resolution.</p><p>If you need further assistance resolving this issue, <a href="mailto:bcurtis@hiserjoy.com">click here to notify the ${systemName} development team</a>.</p>`;

export function errorModalShowStandard(rawError: any) {
  if (isFirebaseError(rawError)) {
    errorModalFirebaseShow(rawError);
  } else {
    errorModalShow(standardErrorMessage, rawError);
  }
}

window.addEventListener('error', (e) => {
  if (isFirebaseError(e.error)) {
    errorModalFirebaseShow(e.error);
  } else {
    errorModalShow(standardErrorMessage, e.error);
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (isFirebaseError(e.reason)) {
    errorModalFirebaseShow(e.reason);
  } else {
    errorModalShow(standardErrorMessage, e.reason);
  }
});
